/* eslint-disable camelcase, no-undef */
import React from 'react';
import Helmet from 'react-helmet';
import saferStringify from '../../util/safer-stringify';
import config from '../../config';
import rawMarkup from '../../util/rawMarkup';
//import twitterScript from '../../util/twitterScript';
//import GooglePageHiding from './GooglePageHiding';
//import GoogleAnalyticsScript from './GoogleAnalyticsScript';
//import GoogleTagManagerScript from './GoogleTagManagerScript';
//import DanishAdScript from './DanishAdScript';

//import StickyIFrameScript from './StickyIFrameScript';
//import StickyIFrameStyle from './StickyIFrameStyle';

const {
  APP_CONFIG_PROPERTY,
  APP_STATE_PROPERTY,
  APP_MOUNT_ID,
  NODE_ENV,
} = config;

const tagManagerTag = country => {
  switch (country) {
  case 'dk':
    return (
      <meta
        name="google-site-verification"
        content="m1M_uIT1jPTwoy5rC8drRb-eyRF3zxvp3F0Ijtgs5Ag"
      />
    );
  default:
    return null;
  }
};

const pages = {
  dk: [
    '127102384036134',
    '1424684267769918',
    '418778601471149',
    '138328229545040',
    '215545355581834',
    '390417824385976',
    '109193472474770',
    '250188514992444',
    '190374010977681',
    '554355337958593',
    '1664967417075411',
  ],
};

export default class Html extends React.PureComponent {



  render() {
    const head = Helmet.rewind();
    const lang = this.props.storeState.language;
    const country = this.props.storeState.country;

    const { isEmbed } = this.props;

    return (
      <html lang={lang}>
        <head>

<script src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js" data-document-language="true" type="text/javascript" charset="UTF-8" data-domain-script="31983956-0083-4cb2-adf9-bcdb75c6db9b" ></script>
<script type="text/javascript">
function OptanonWrapper() { }
</script>

  
          {head.title.toComponent()}
          {head.meta.toComponent()}
          {head.link.toComponent()}
          <meta charSet="utf-8" />
          {tagManagerTag(country)}
          <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
          />
 			
          <meta http-equiv="Referrer-Policy" content="no-referrer, strict-origin-when-cross-origin"></meta>


          
<link href="//players.brightcove.net/videojs-pip/1/videojs-pip.css" rel="stylesheet"/>

<link href="https://fonts.google.com/selection?category=Serif&selection.family=Lato|PT+Serif:700|Roboto+Slab:700&stylecount=4&width=4" rel="stylesheet"/> 
<link href="https://fonts.googleapis.com/css?family=Martel+Sans:400,200,300,600,700,800,900&subset=latin,devanagari,latin-ext" rel="stylesheet"/>
          <link
            rel="stylesheet"
            type="text/css"
            href={__webpack_public_path__ + this.props.assetsMapper.styles.css}
          />
          <link
            rel="shortcut icon"
            href={`/browsericons/dk/logo_16.ico`}
            type="image/x-icon"
          />
          <link
            rel="icon"
            sizes="196x196"
            href={`/browsericons/dk/web-clip-icon_new.png`}
          />
          <link
            rel="apple-touch-icon"
            href={`/browsericons/dk/web-clip-icon_new.png`}
          />

          <script
            dangerouslySetInnerHTML={rawMarkup(
              `window['${APP_STATE_PROPERTY}']=${saferStringify(
                this.props.storeState,
              )};`,
            )}
          />
          <script
            dangerouslySetInnerHTML={rawMarkup(
              `window['${APP_CONFIG_PROPERTY}']=${JSON.stringify(
                this.props.config,
              )};`,
            )}
          />
          <script
            src={__webpack_public_path__ + this.props.assetsMapper.common.js}
          />
          <script
            src={__webpack_public_path__ + this.props.assetsMapper.bundle.js}
            async
          />
          <script src={__webpack_public_path__ + 'avod-player.js'} async />
  		 <script type="text/plain" className="optanon-category-C0002-C0003-C0004-C0005-C0007-C0012" async='async' src='https://tags.adnuntius.com/concept_cph/zUxMC1rEr.prod.js'></script>
  		 
		<script src="https://code.jquery.com/jquery-1.11.2.min.js"></script>
<script src="https://players.brightcove.net/1752604059001/Zbggd6KGf_default/index.min.js" type="text/javascript"></script>

        <script
            dangerouslySetInnerHTML={rawMarkup(
              `videojs.getPlayer('iframesport').ready(function() {var myPlayer = this;myPlayer.pip();
});`
            )}
          />

		  
		  
        </head>
        <body>

          <div
            id={APP_MOUNT_ID}
            dangerouslySetInnerHTML={rawMarkup(this.props.markup)}
          />

          {NODE_ENV === 'production' &&
            <script src="https://cdn.ravenjs.com/3.7.0/raven.min.js" />}
          {!isEmbed &&
            <script src="https://cdn-fonts-mtgx-tv.akamaized.net/jwr0msz.js" />}
          {!isEmbed &&
            <script
              dangerouslySetInnerHTML={rawMarkup(
                `try{Typekit.load({ async: true });}catch(e){}`,
              )}
            />}
      

        </body>
        
      </html>
    );
  }
}

Html.propTypes = {
  storeState: React.PropTypes.object.isRequired,
  config: React.PropTypes.object.isRequired,
  isEmbed: React.PropTypes.bool,
  markup: React.PropTypes.string.isRequired,
  enetpulseSettings: React.PropTypes.object.isRequired,
  assetsMapper: React.PropTypes.shape({
    common: React.PropTypes.shape({
      js: React.PropTypes.string.isRequired,
    }),
    bundle: React.PropTypes.shape({
      js: React.PropTypes.string.isRequired,
    }),
    styles: React.PropTypes.shape({
      css: React.PropTypes.string.isRequired,
    }),
  }),
};



// WEBPACK FOOTER //
// ./src/component/Page/Html.jsx